import './GlobalStyles.scss';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function GlobalStyles(props: any) {
  return props.children;
}
export default GlobalStyles;
